export const refugesHelper = {
  cleanApiData,
  prepareToSend
}

function cleanApiData(refuge){
  const cleanData = {};
  cleanData.id = refuge.id;
  cleanData.oldid = refuge.oldid;
  cleanData.nombre = refuge.nombre;
  cleanData.plazas = refuge.plazas;
  cleanData.habitaciones = refuge.habitaciones;

  return cleanData;
}

function prepareToSend(bookign, element='reserva', cadena = false){
  let form_data = new FormData()
  let data = null;
  if(cadena) {
    data = bookign
  }else{
    data = []
    let contenido = JSON.stringify(bookign)
    data.push(contenido)
  }

  form_data.append(element, data)

  return form_data
}






// WEBPACK FOOTER //
// ./src/_helpers/refuge.helper.js